import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import auth from './modules/auth.module'
import surveys from './modules/surveys.module'
import survey from './modules/survey.module'
import notification from './modules/notification.module'
import layout from './modules/layout.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    surveys,
    survey,
    notification,
    layout,
  },
})
